import axios from "axios";

const {REACT_APP_API_BASE_URL_BASKET} = process.env;

function _getBaseURL(url) {
  let currentPath = window.location.href;

  if (currentPath.includes("https://") && url.includes("http://")) {
    url = "https://" + new URL(currentPath).hostname + "/api5/";
  } else {
  }
  return url;
}


const fetcher = axios.create({
  baseURL: _getBaseURL(REACT_APP_API_BASE_URL_BASKET)
});

export function getFetcherBasket() {
  return fetcher;
}

